import React from 'react';
import styled from 'styled-components/macro';
import ProductCard from '@components/orders/components/ProductCard';

type PropsI = {
  products: any[];
  onAddToCart: (item:string, quantity: number) => void;
};

const debug = false;
const ProductsCarousel = (props:PropsI) => {
  const { products, onAddToCart } = props;
  // For Future: const [carouselStart, setCarouselStart] = useState<number>(0);

  debug && console.log('ProductCarousel | products:', products);

  if (products === undefined) {
    return(<>No Products Available</>)
  }

  return (
    <>
      { products.length === 0 ? <>No available products</>
        :
        <ProductsContainer>
          { products.map((item) => {
            return(
            <ProductCard
              item={item}
              onAddToCart={onAddToCart}
            />
            )})}
        </ProductsContainer>
      }
    </>
  );
};

export default ProductsCarousel;

const ProductsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  justify-content: center;
`;
